export { default } from "./GiftCardInformations";
